import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import MainLoading from '../../utils/MainLoading';

const ContactModal = (props) => {
    const [cmpData, setCmpData] = useState([])
    const data = useSelector(state => state.saloon_detail)

    useEffect(() => {
        setCmpData(data.saloon_detail.users.filter(item => item.id === props.id)[0])
    }, [props.id])

  return (
        <>
            {props.show && (
                <Modal show={props.show} className="expo_modal">
                    {/* {userprofile.loading ?
                        <MainLoading  />
                    : */}
                        <>
                            <Modal.Header>
                                <Modal.Title>ارتباط تصویری با غرفه </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <h6 className='text-center py-4'> در حال حاضر امکان برقراری ارتباط تصویری با غرفه موجود نیست </h6>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={props.close} className='px-3 btn-sm'>
                                    بستن
                                </Button>
                            </Modal.Footer>
                        </>
                    {/* } */}
                </Modal>
            )}
        </>
    )
};

export default ContactModal;
